<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.product_brand_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <piaf-breadcrumb heading="Product Brands"/>

        <div class="d-flex flex-row">
            <span class="iconsminds-stop mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,
                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum
                officiis quia quos rem totam vitae.
            </p>
        </div>

        <div>
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchProductBrands" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="separator mb-4"></div>

            <b-card class="mb-4" :title="'List of Product Brands'">
                <b-refresh-button class="text-data-link" @click="refreshData"/>

                <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                         :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                         :current-page="meta.current_page" :fields="table_fields" :items="fetchProductBrands">

                    <template v-slot:cell(id)="data">
                        <span v-text="data.item.data.attributes.code"/>
                    </template>

                    <template v-slot:cell(name)="data">
                     <span @click="productBrandDetails(data.item)" style="cursor: pointer;" class="text-data-link"
                           v-text="data.item.data.attributes.name"/>
                    </template>

                    <template v-slot:cell(description)="data">
                        <span v-text="data.item.data.attributes.description"/>
                    </template>

                    <template v-slot:cell(image)="data">
                        <span v-text="data.item.data.attributes.image"/>
                    </template>

                    <template v-slot:cell(actions)="data">
                        <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                    menu-class="mt-2" style="width: 75px;" right no-caret>

                            <template slot="button-content">
                                <i class="btn-circle simple-icon-options-vertical"/>
                            </template>

                            <b-dropdown-item @click="editProductBrand(data.item.brand_id)">
                                Edit
                            </b-dropdown-item>

                            <b-dropdown-item @click="deleteProductBrand(data.item)">
                                Delete
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                </b-table>
                <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                              v-model="meta.current_page">
                    <template v-slot:next-text>
                        <i class="simple-icon-arrow-right"/>
                    </template>

                    <template v-slot:prev-text>
                        <i class="simple-icon-arrow-left"/>
                    </template>

                    <template v-slot:first-text>
                        <i class="simple-icon-control-start"/>
                    </template>

                    <template v-slot:last-text>
                        <i class="simple-icon-control-end"/>
                    </template>
                </b-pagination>
            </b-card>

            <ProductBrandFormModal :edit="edit" @updated="tableKey++"/>

            <ProductBrandDeleteModal v-if="brand" :brand="brand" @updated="tableKey++"/>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import ProductBrandFormModal from "./modals/ProductBrandFormModal";
    import ProductBrandDeleteModal from "./modals/ProductBrandDeleteModal";


    export default {
        name: "ProductBrandsList",

        components: {
            ProductBrandFormModal,
            ProductBrandDeleteModal
        },

        data () {
            return {
                loading: false,
                edit: false,
                tableKey: 0,
                brand: null
            }

        },

        computed: {
            ...mapGetters({
                table_fields: 'getProductBrandTableFields',
                meta: 'getProductBrandMeta'
            })
        },

        methods: {
            changeOrderBy(key, label) {
                this.meta.order_by = label;
                this.meta.sort_by = key;
            },

            searchProductBrands: _.debounce(function (event) {
                if (this.meta.search && this.meta.search.length >= 3) {
                    this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
                }
            }, 300),

            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            refreshData() {
                this.$store.commit('resetProductBrandsMeta');
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            },

            changeSorting(event) {
                (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
            },

            fetchProductBrands() {
                return this.$store.dispatch('fetchProductBrands')
                    .then(brands => {
                        return brands.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            productBrandDetails(brand) {
                this.brand = brand;

                setTimeout(() => {
                    this.$bvModal.show('brand_details');
                }, 1);
            },


            editProductBrand(product_brand_id) {
                this.edit = true;

                this.$store.dispatch('fetchEditProductBrand', product_brand_id)
                    .finally(response => {
                        this.$bvModal.show('product_brand_form');
                    });
            },

            deleteProductBrand(brand) {
                this.brand = brand;

                setTimeout(() => {
                    this.$bvModal.show('brand_delete');
                }, 1);
            },
        }
    }
</script>

<style scoped>

</style>
